import ShellSessionStorageDAOImpl from '../../../dao/ShellSessionStorageDAOImpl';
import StorageLocale from './StorageLocale';
import LocaleSessionRepository from './LocaleSessionRepository';

const shellDAO = new ShellSessionStorageDAOImpl();
const localeSessionRepository = new LocaleSessionRepository({ shellDAO });

export { localeSessionRepository, StorageLocale };
